import { render, staticRenderFns } from "./AllClaims.vue?vue&type=template&id=7a3bff89&scoped=true&"
import script from "./AllClaims.vue?vue&type=script&lang=js&"
export * from "./AllClaims.vue?vue&type=script&lang=js&"
import style0 from "./AllClaims.vue?vue&type=style&index=0&id=7a3bff89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3bff89",
  null
  
)

export default component.exports